import { derived, type Readable } from 'svelte/store';
import { app } from '../../../stores/app';

/**
 * Czy zalogowany użytkownik może zapisywać (can_write z app_user).
 *
 * Brak wczytanych uprawnień (null) traktujemy jak pełny dostęp, a nie jak blokadę: store jest
 * wypełniany przed pierwszym renderem (US-013), a konto z can_write = true nie może zobaczyć
 * żadnej zmiany w GUI. Wyłączamy więc akcje wyłącznie przy jawnym canWrite === false.
 * Właściwym guardem jest i tak backend - GUI ma tylko nie kusić do niewykonalnych akcji.
 */
export const canWrite: Readable<boolean> = derived(
    app,
    $app => $app.permissions?.canWrite !== false
);

/** Klucz i18n tooltipa każdej akcji zapisu wyłączonej z powodu uprawnień. */
export const writeDisabledTooltip = 'You do not have permission to save changes';

/**
 * Klucz i18n baneru nad stroną, której wszystkie kontrolki edycji są wyłączone przez brak can_write.
 * Tooltip wyjaśnia pojedynczą akcję, baner - cały ekran, dlatego to osobny komunikat.
 */
export const writeDisabledBanner =
    'Your account has read-only access - changes on this page cannot be saved';
